"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.empty = exports.MetricUnit = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel["Debug"] = "debug";
    LogLevel["Error"] = "error";
    LogLevel["Info"] = "info";
    LogLevel["Silly"] = "silly";
    LogLevel["Trace"] = "trace";
    LogLevel["Verbose"] = "verbose";
    LogLevel["Warn"] = "warn";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
var MetricUnit;
(function (MetricUnit) {
    MetricUnit["Count"] = "Count";
})(MetricUnit || (exports.MetricUnit = MetricUnit = {}));
exports.empty = 'NOTSET';
//# sourceMappingURL=structures.js.map